/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * LuLogTable response payload
 * @export
 * @interface CnsDashboard
 */
export interface CnsDashboard {
    /**
     * 
     * @type {number}
     * @memberof CnsDashboard
     */
    nbPidValidated?: number;
    /**
     * 
     * @type {number}
     * @memberof CnsDashboard
     */
    nbPidContested?: number;
    /**
     * 
     * @type {number}
     * @memberof CnsDashboard
     */
    nbMHSent?: number;
}

/**
 * Check if a given object implements the CnsDashboard interface.
 */
export function instanceOfCnsDashboard(value: object): value is CnsDashboard {
    return true;
}

export function CnsDashboardFromJSON(json: any): CnsDashboard {
    return CnsDashboardFromJSONTyped(json, false);
}

export function CnsDashboardFromJSONTyped(json: any, ignoreDiscriminator: boolean): CnsDashboard {
    if (json == null) {
        return json;
    }
    return {
        
        'nbPidValidated': json['nbPidValidated'] == null ? undefined : json['nbPidValidated'],
        'nbPidContested': json['nbPidContested'] == null ? undefined : json['nbPidContested'],
        'nbMHSent': json['nbMHSent'] == null ? undefined : json['nbMHSent'],
    };
}

export function CnsDashboardToJSON(json: any): CnsDashboard {
    return CnsDashboardToJSONTyped(json, false);
}

export function CnsDashboardToJSONTyped(value?: CnsDashboard | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nbPidValidated': value['nbPidValidated'],
        'nbPidContested': value['nbPidContested'],
        'nbMHSent': value['nbMHSent'],
    };
}

